export const IMG = "https://static.prod-images.emergentagent.com/jobs/23aa0e47-791b-4dbb-bfa4-538f8fca177e/images/";
export const IMAGES = {
  hero: IMG + "a6c489ce3755aeba682ee5f1004772a344dc11be9f5356c2dc1e2aa36a037969.jpeg",
  agnes: "https://customer-assets-wrfwihn1.emergentagent.net/job_cottage-library/artifacts/ls5dxyt5_60A137F2-7792-4504-B9EE-3A04D0076921.png",
  journal: IMG + "0b0d3c0b884674d6ea8aaa04bf11b633dc70c091edde9a6bcdb9a188e1981384.jpeg",
  seasonalBanner: IMG + "9d9ccd7290ffe098eb5b57d9c0fe63d51f103ba6cee90804cf34401cdad64eb8.jpeg",
  herbHub: "https://images.pexels.com/photos/9350696/pexels-photo-9350696.jpeg",
  pantryHub: "https://images.unsplash.com/photo-1777499455310-80354aa1021f",
  breadHub: "https://images.unsplash.com/photo-1613396874083-2d5fbe59ae79",
  seasonalHub: "https://images.unsplash.com/photo-1613291511109-ea3d67e68a25",
  agnesAi: IMG + "8e88ed2c155c36e0e18edc104332eaaa743b898aefbe78268aa0f0dc10bd505e.jpeg",
};

export const NAV = [
  { label: "The Cottage Library", to: "/library" },
  { label: "About Agnes", to: "/about" },
  { label: "Pantry & Preserving", to: "/pantry-preserving" },
  { label: "Herbal Wisdom", to: "/herbal-wisdom" },
  { label: "Recipes", to: "/recipes" },
  { label: "Seasonal Living", to: "/seasonal-living" },
  { label: "Journal", to: "/journal" },
  { label: "Daily Recipe", to: "/daily-recipe" },
  { label: "Ask Agnes", to: "/agnes-ai" },
  { label: "The Cottage Store", to: "/store" },
  { label: "Affiliate Shop", to: "/shop" },
];
